import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useGetGalaxies } from '../../hooks/useGetGalaxies';
import useInfiniteScroll from '../../hooks/useInfiniteScroll';
import { AuthContext } from '../../context/AuthContext';
import Topbar from '../../components/topbar/Topbar';
import Sidebar from '../../components/sidebar/Sidebar';
import Rightbar from '../../components/rightbar/Rightbar';
import { useMediaQuery } from 'react-responsive';
import TopbarNotification from '../../components/topbarNotification/TopbarNotification';
import CreateGalaxyForm from '../../components/createGalaxyForm/CreateGalaxyForm';
import './galaxy.css';
import { useGetConversations } from '../../hooks/useGetConversations';
import GalaxyRightBarMobile from '../../components/galaxyRightbarMobile/GalaxyRightbarMobile';
import useMobileView from '../../hooks/useMobileView';
import { useTheme } from '../../context/ThemeContext';
import { CAMDEN_LIVE_ROUTES } from '../../utils/galaxyRegionHub';

const formatGalaxyJGK = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return null;
  return `JGK ${Math.floor(amount).toLocaleString('en-US')}`;
};

const getGalaxyMemberCount = (galaxy) =>
  galaxy?.members?.length ?? galaxy?.subscribers?.length ?? 0;

const getGalaxySummary = (galaxy) => {
  const value = galaxy?.summary || galaxy?.description || '';
  return String(value).trim();
};

const getGalaxyRatingLabel = (galaxy) => {
  const average = Number(galaxy?.ratingsAverage);
  const quantity = Number(galaxy?.ratingsQuantity);
  if (!Number.isFinite(average) || average <= 0) return null;
  if (Number.isFinite(quantity) && quantity > 0) {
    return `${average.toFixed(1)} from ${quantity} rating${
      quantity === 1 ? '' : 's'
    }`;
  }
  return average.toFixed(1);
};

export default function Galaxies() {
  const [page, setPage] = useState(1);
  const [galaxyItems, setGalaxyItems] = useState([]);
  const [showForm, setShowForm] = useState(false); // New state for the form visibility
  const [conversations, setConversations] = useState([]);
  const [totalUnReadMessages, setTotalUnReadMessages] = useState(0);
  const [jgkTokenSum, setJgkTokenSum] = useState(0);
  const [galaxyChatOnlinePlayers, setGalaxyChatOnlinePlayers] = useState([]);

  const { player } = useContext(AuthContext);
  const mobileView = useMobileView();
  const { darkTheme } = useTheme();

  const handleJgkTokenSum = useCallback((sum) => {
    setJgkTokenSum(sum);
  }, []); // No dependencies, as setJgkTokenSum is stable

  const onSuccess = (data) => {
    // console.log('data: ', data);
  };

  const onError = (err) => {
    // console.log('err: ', err);
  };

  //   console.log(page);

  const { data, status } = useGetGalaxies(onSuccess, onError, player, page);

  if (status === 'success' && data) {
    // console.log('data: ', data.data.data);
  }
  const loadMore = () => {
    setPage((old) => old + 1);
  };

  // Use the custom hook
  useInfiniteScroll(loadMore);

  useEffect(() => {
    let mounted = true;
    if (status === 'success' && data) {
      const galaxies = data.data.data; // Access the array of galaxies
      if (Array.isArray(galaxies)) {
        setGalaxyItems((prevGalaxies) => {
          const existingGalaxyIds = prevGalaxies.map((galaxy) => galaxy._id);
          const newGalaxies = galaxies.filter(
            (galaxy) => !existingGalaxyIds.includes(galaxy._id),
          );
          if (mounted) {
            const sortedGalaxies = [...prevGalaxies, ...newGalaxies].sort(
              (a, b) => {
                // Sort by marketValue first
                const marketValueA = Number(a.marketValue) || 0;
                const marketValueB = Number(b.marketValue) || 0;
                if (marketValueB !== marketValueA) {
                  return marketValueB - marketValueA;
                }
                // If marketValue is the same, sort by subscribers
                const subscribersA = a.subscribers?.length || 0;
                const subscribersB = b.subscribers?.length || 0;
                return subscribersB - subscribersA;
              },
            );

            return sortedGalaxies;
          }
          return prevGalaxies;
        });
      }
    }
    return () => {
      mounted = false;
    };
  }, [data, status]);

  const onSuccess2 = (data) => {
    // console.log('data: ', data);
  };

  const onError2 = (err) => {
    // console.log('err: ', err);
  };

  const {
    data: conversationsData,
    isSuccess,
    status: conversationStatus,
    refetch,
  } = useGetConversations(onSuccess2, onError2, player);
  // console.log(data);

  useEffect(() => {
    //set conversations
    if (isSuccess) {
      // console.log(isSuccess);
      setConversations(conversationsData);
    }
  }, [conversationsData, isSuccess]);

  const canCreateGalaxy =
    player?.data?.player?.role === 'admin' ||
    player?.data?.player?.role === 'galaxyAdmin';

  //   console.log(galaxyItems);
  return (
    <>
      {/* <Topbar
        conversationsData={conversationsData}
        conversationsStatus={conversationStatus}
        refetchConversations={refetch}
        parent="Galaxy"
        conversations={conversations}
        setConversations={setConversations}
        totalUnReadMessages={totalUnReadMessages}
        setTotalUnReadMessages={setTotalUnReadMessages}
      /> */}
      {/* {mobileView && <TopbarNotification />} */}
      <div
        className={
          darkTheme
            ? 'dark-theme blackBg homeContainer galaxies-page-shell'
            : 'homeContainer galaxies-page-shell'
        }
      >
        {!mobileView && <Sidebar />}
        <div className="feed galaxies-feed">
          <section className="galaxies-hero" aria-labelledby="galaxies-title">
            <div>
              <p className="galaxies-eyebrow">JG community layer</p>
              <h1 id="galaxies-title">Galaxies</h1>
              <p className="galaxies-hero-copy">
                Community spaces for local posts, live chat, and JG LocalOps
                region launches.
              </p>
            </div>
            <div className="galaxies-hero-actions">
              <Link
                className="galaxies-secondary-link"
                to={CAMDEN_LIVE_ROUTES.howItWorks}
              >
                How JG LocalOps works
              </Link>
            </div>
          </section>

          <section
            className="galaxies-featured"
            aria-label="Featured LocalOps region Galaxy"
          >
            <div className="galaxies-featured-card">
              <div>
                <p className="galaxies-eyebrow">LocalOps region hub</p>
                <h2>Camden Live</h2>
                <p className="galaxies-featured-subtitle">
                  The local community hub for JG LocalOps Camden.
                </p>
                <p>
                  Follow local posts, chat with nearby players, and connect
                  with the Camden LocalOps launch.
                </p>
              </div>
              <div className="galaxies-featured-actions">
                <Link
                  className="galaxies-primary-cta"
                  to={CAMDEN_LIVE_ROUTES.galaxy}
                >
                  Open Camden Live
                </Link>
                <Link
                  className="galaxies-secondary-cta"
                  to={CAMDEN_LIVE_ROUTES.region}
                >
                  Explore JG LocalOps Camden
                </Link>
                <Link
                  className="galaxies-text-cta"
                  to={CAMDEN_LIVE_ROUTES.howItWorks}
                >
                  How JG LocalOps works
                </Link>
              </div>
            </div>
          </section>

          <div className="galaxies-toolbar">
            <button
              className="postButtonRank galaxies-create-button"
              onClick={() => setShowForm(!showForm)}
            >
              {showForm ? 'Hide create form' : 'Create Galaxy'}
            </button>
          </div>
          {showForm &&
            (!canCreateGalaxy ? (
              <div className="centerContainer">
                <div className="errorText">
                  You must be a galaxyAdmin or admin to create a galaxy. Send a
                  chat message to joegalaxy to request.
                </div>
              </div>
            ) : (
              <div className="container">
                <div className="centerContent">
                  <CreateGalaxyForm />
                </div>
              </div>
            ))}
          <div
            className={
              darkTheme
                ? 'dark-theme blackBg centered-flex galaxies-list-wrap'
                : 'centered-flex galaxies-list-wrap'
            }
          >
            <ul
              className={
                darkTheme
                  ? 'app dark-theme blackBg flex-column-start galaxies-list'
                  : 'flex-column-start galaxies-list'
              }
            >
              {galaxyItems.map((galaxy) => {
                const memberCount = getGalaxyMemberCount(galaxy);
                const summary = getGalaxySummary(galaxy);
                const marketValue = formatGalaxyJGK(galaxy.marketValue);
                const ratingLabel = getGalaxyRatingLabel(galaxy);

                return (
                  <li key={galaxy._id}>
                    <article
                    className={
                      darkTheme
                        ? 'blackBg dark-theme custom-box galaxies-card'
                        : 'custom-box galaxies-card'
                    }
                    >
                      <div className="galaxies-card-header">
                        <div>
                          <p className="galaxies-card-kicker">
                            Local community hub
                          </p>
                          <h2 className={darkTheme ? 'dark-theme blackBg' : ''}>
                        {galaxy.name}
                          </h2>
                        </div>
                        <span className="galaxies-card-status">Open</span>
                      </div>
                      {/* <GalaxyRightBarMobile
                        onJgkTokenSumChange={handleJgkTokenSum}
                        galaxy={galaxy}
                        parent="galaxyPage"
                      /> */}
                      {summary && (
                        <p className="galaxies-card-summary">{summary}</p>
                      )}
                      <div className="galaxies-card-meta">
                        {galaxy.location && <span>{galaxy.location}</span>}
                        <span>
                          {memberCount}{' '}
                          {memberCount === 1 ? 'subscriber' : 'subscribers'}
                        </span>
                        {marketValue && <span>{marketValue}</span>}
                        {ratingLabel && <span>{ratingLabel}</span>}
                      </div>
                      <Link
                        className="galaxies-card-cta"
                        to={{
                          pathname: `/galaxies/${galaxy._id}`,
                        }}
                      >
                        Open Galaxy
                      </Link>
                    </article>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        {!mobileView && <Rightbar />}
      </div>
    </>
  );
}
